import { DocumentTypeDTO } from '../../http/dtos/document-types/document-typesDTO';
import httpClient from '../../http/httpClient';

export const documentTypeRepository = {
    GetDocumentTypeList: () => {
        return httpClient
            .get('/document-types')
            .then((response: DocumentTypeDTO[]) => response);
    },
};
